"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadWriteTokenPrefix = "read-write-token:";
//# sourceMappingURL=resource-types.js.map